"use client";
// ════════════════════════════════════════════════════════════════════════════════════════════════
// DẤU HIỆU "ĐANG CHUYỂN TRANG" — đặt BÊN TRONG một <Link> để nó tự biết link ĐÓ đang chờ.
//
// 🩸 VÌ SAO KHÔNG DÙNG `loading.tsx` NỮA (đo 16/08/2026, bản dựng THẬT, lặp lại 10/10 lần):
//    Chỉ cần TỒN TẠI một `app/loading.tsx` — kể cả một tệp 3 dòng trần không hook nào — là MỌI cú
//    chuyển trang phía trình duyệt đứng im vĩnh viễn: máy chủ trả gói dữ liệu 200 trong 4 ms, mà
//    giao diện không bao giờ vẽ lại, URL không đổi. Bấm menu, bấm chip lọc, `router.push`,
//    `router.refresh` — chết hết như nhau. Bỏ tệp đó ra: 10/10 chạy. Trả vào: 0/10.
//    Đây LÀ LỖI CỦA NEXT, không phải mã mình: vercel/next.js#86151 ("`loading.js` sometimes causes
//    soft-navigation to get stuck… despite receiving it from the server"), vá ở PR #95391 gộp vào
//    nhánh canary 02/07/2026 — **KHÔNG lùi về dòng 15.x** mình đang chạy (15.5.19).
//    Người dùng thấy đúng câu Phương kêu: *"bấm không mở được, phải đăng xuất rồi vào lại"*.
//
// ⛳ CẬP NHẬT 01/09/2026 — GIỮ NGUYÊN BẢN GHI 16/08 Ở TRÊN: đo lại trên Next 16.3.1 bằng
//    `next build && next start`: 10/10 liên kết cập bến, `router.push` qua ô lệnh cũng cập bến khi
//    có `app/loading.tsx`. Lỗi #86151 đã hết trên dòng hiện tại, nên fallback cấp trang được mở lại.
//    `NhipChuyenTrang` vẫn sống: nó báo đúng LINK vừa bấm; fallback cấp trang lo phần trang sắp về.
//
// 👉 `loading.tsx` sinh ra để giữ luật nhà "mọi cú bấm phải có dấu hiệu đang chờ". Luật đó KHÔNG bỏ
//    — chỉ đổi đường: `useLinkStatus()` (Next ≥ 15.3, đang có sẵn) báo trạng thái chờ của ĐÚNG link
//    vừa bấm mà KHÔNG dựng ranh giới Suspense nào ⇒ không dính lỗi trên. Bộ lọc trong trang thì đã
//    có `FilterBusy` ("Đang lọc…") lo, không đụng gì.
//
// ⚠️ Chỉ chạy khi là con cháu của một <Link>; đặt ngoài thì `pending` luôn false (không nổ, chỉ câm).
// ════════════════════════════════════════════════════════════════════════════════════════════════
import { useLinkStatus } from "next/link";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export default function NhipChuyenTrang({ className }: { className?: string }) {
  const { pending } = useLinkStatus();
  if (!pending) return null;
  return (
    <>
      <Loader2
        aria-hidden="true"
        className={cn("h-3.5 w-3.5 shrink-0 animate-spin motion-reduce:animate-none", className)}
      />
      <span className="sr-only">Đang mở…</span>
    </>
  );
}
